import React, {Component} from 'react';
import { Link } from 'react-router-dom';

// Manage the styling of nav links (active vs. inactive)
class NavLink extends Component {
    render() {
        return (
            <li className={'nav-item ' + this.props.className + (this.props.isActive ? 'active' : '')}>
                <Link
                    className={`nav-link ${this.props.linkClassName}`}
                    to={this.props.path}
                >
                    {
                        this.props.isButton ?
                            <button className={`btn ${this.props.btnClassName}`}>
                                {this.props.text}
                            </button>
                            :
                            this.props.text
                    }
                    {
                        this.props.text === 'Messages' &&
                        this.props.notificationMessages > 0 &&
                            <span className="notification-badge">
                                {this.props.notificationMessages > 9 ? '9+' : this.props.notificationMessages}
                            </span>
                    }
                </Link>
            </li>
        );
    }
}

export default NavLink;
